<template>
  <div
    class="washing-symbol"
    :class="withBorder ? 'border' : ''"
  >
    <v-img
      :src="image"
      width="30px"
      height="30px"
      contain
      aspect-ratio="1"
    />
  </div>
</template>

<script>
  export default {
    name: "WashingSymbol",
    props: {
      property: {
        type: String,
        default: null,
        description: "The washing property, check the data method for available properties"
      },
      withBorder: {
        type: Boolean,
        default: false,
        description: "If the washing symbol should get a border"
      }
    },
    data: () => ({

      symbols: {

        // Bleach
        // ---

        inybleach: 'BleachProperties/inybleach.png',
        inycoldbleach: 'BleachProperties/inycoldbleach.png',
        inydontbleach: 'BleachProperties/inydontbleach.png',

        // Clear
        // ---

        inycleara: 'ClearProperties/inycleara.png',
        inyclearf: 'ClearProperties/inyclearf.png',
        inyclearp: 'ClearProperties/inyclearp.png',
        inyclearspecf: 'ClearProperties/inyclearspecf.png',
        inyclearspecp: 'ClearProperties/inyclearspecp.png',
        inydontchemclear: 'ClearProperties/inydontchemclear.png',

        // Dry
        // ---

        inydontdry: 'DryProperties/inydontdry.png',
        inydry: 'DryProperties/inydry.png',
        inynormaldry: 'DryProperties/inynormaldry.png',
        inysensitivedry: 'DryProperties/inysensitivedry.png',

        // Iron
        // ---

        inydontiron: 'IronProperties/inydontiron.png',
        inyironpoint1: 'IronProperties/inyironpoint1.png',
        inyironpoint2: 'IronProperties/inyironpoint2.png',
        inyironpoint3: 'IronProperties/inyironpoint3.png',

        // Wash
        // ---

        inyanticreasewash30: 'WashProperties/inyanticreasewash30.png',
        inyanticreasewash40: 'WashProperties/inyanticreasewash40.png',
        inyanticreasewash60: 'WashProperties/inyanticreasewash60.png',
        inydontwash: 'WashProperties/inydontwash.png',
        inyhandwash: 'WashProperties/inyhandwash.png',
        inynormalwash30: 'WashProperties/inynormalwash30.png',
        inynormalwash40: 'WashProperties/inynormalwash40.png',
        inynormalwash60: 'WashProperties/inynormalwash60.png',
        inynormalwash95: 'WashProperties/inynormalwash95.png',
        inywoolwash40: 'WashProperties/inywoolwash40.png',
      }

    }),
    computed: {
      image() {
        if (this.property in this.symbols) {
          return require(`@/assets/icons/washing_symbols/${this.symbols[this.property]}`)
        }
        return ''
      }
    }
  }
</script>

<style>

div.washing-symbol.border {
  border: 1px solid #ddd;
  height: 40px;
}

div.washing-symbol {
  padding: 4px;
}

</style>
